<template>
	<v-dialog v-model="addRoleDialog" width="600">
    <custom-dialog>
      <template v-slot:title>
        {{'Role 추가하기'}}
        <button id="dialog_exit">
          <img src="@/assets/images/popup_close.png" id="btn_img"
						@click="addRoleDialog = false">
        </button>
      </template>
      <template v-slot:body>
        <v-row class="ma-0 pa-0" justify="center">
          <v-col class="ma-0 pa-0" cols="10">
            <v-row class="ma-0 pa-0 pt-2 mb-10" align="center" justify="center">
							<v-col class="ma-0 pa-0" cols="10" align="left">
                {{'Role Group Name'}}
              </v-col>
              <v-col class="ma-0 pa-0 mt-1" cols="10">
                <input class="member_input" v-model="roleGroupName" readonly>
              </v-col>

							<v-col class="ma-0 pa-0 mt-5" cols="10" align="left">
                {{'Role List'}}
              </v-col>
              <v-col class="ma-0 pa-0 mt-1" cols="10" style="width:100%;">
								<v-select background-color="#272727" dark v-model="selectedRoleKey"
									:items="roleList" dense hide-details outlined 
									item-text="name" item-value="key"
								></v-select>
							</v-col>
            </v-row>
						<v-row class="ma-0 pa-0 mt-5 pb-2" align="center" justify="center">
							<v-btn class="ma-0 pa-0" id="grey_btn" @click="addRoleDialog = false"
								width="8rem" height="2rem">{{'취소'}}</v-btn>
							<v-btn class="ma-0 pa-0 ml-2" id="blue_btn" :loading="loading"
								width="8rem" height="2rem" @click="addRole">{{'확인'}}</v-btn>
						</v-row>
          </v-col>
        </v-row>
      </template>
    </custom-dialog>
  </v-dialog>
</template>

<script>
import mixin from '@/mixin';
import CustomDialog from '@/components/Modal.vue';
export default {
	props: {
		dialogVisible: Boolean,
		roleGroupName: String,
		roleGroupKey: String,
	},
	components: {
		CustomDialog
	},
	mixins: [mixin.common],
	data: () => ({
		loading: false,
    addRoleDialog: false,
		roleList: [],
		selectedRoleKey: null
	}),
	watch: {
		dialogVisible: function(item) {
			this.addRoleDialog = item;
		},
		addRoleDialog: function(item) {
			this.$emit('visible', item);
		},
		roleGroupKey: function(item) {
			if(this.roleList.length == 0) {
				this.fetchRoleListData();
			}
		},
	},
	mounted() {
		if(this.$store.state.userData.admin.xApiKey != null
			|| this.$store.state.userData.admin.xApiKey != undefined) {
			if(this.roleList.length == 0) {
				this.fetchRoleListData();
			}
		}
	},
	methods: {
		async fetchRoleListData() {
			let params = {};
			await this.networkController.getAllAccountRoleList(params)
			.then(async (res) => {
				this.roleList = res.data;
			}).catch(error => { });
		},
		async addRole() {
			this.loading = true;
			if(this.selectedRoleKey == null) {
				this.$dialog.message.warning('Role을 선택해주세요', {
					position: 'top', timeout: 2000
				});
				this.loading = false;
				return;
			}
			let params = {
        accountRoleKey: this.roleGroupKey, // RoleGroup key (roleGroupCd -> accountRoleKey)
        accountAuthKey: this.selectedRoleKey, // Role key (role -> accountAuthKey)
			};
			await this.networkController.addRole(params)
			.then(async (res) => {
				this.loading = false;
				this.addRoleDialog = false;
			}).catch(error => { 
				this.loading = false;
			});
		}
	}
}
</script>

<style lang="scss" scoped>
.member_input {
  width: 100%;
  padding-left: 1em;
  color: white;
  background-color: #272727;
  border: 1px solid #4A4A4A;
  border-radius: 3px;
  height: 2rem;
}
.v-list{
  background: #171921 !important;
	border: 1px solid #4A4A4A;
}
::v-deep {
  .v-list-item__content{
    color: white;
  }
	// Select Box Height 설정
	.v-text-field--outlined > .v-input__control > .v-input__slot {
		min-height: 35px !important;
	}
	.v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control {
		height: 35px;
	}
}
</style>